// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__Tym7C","actions":"styles_actions__oqiYk","button":"styles_button__UteHF"};